import { Component } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { Faq } from '../models/common.models';
import { environment } from '../../environments/environment';



@Component({
  selector: 'app-faq',
  imports: [MatExpansionModule],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss',
})
export class FaqComponent {
  faqs: Faq[] = environment.faqs;
}
